<template>
  <div class="indexPage">
    <div class="list">
      <div class="item" v-if="dataItem != ''">
        <div class="block_one">
          <div class="column flex-rowl">
            <p class="label">创建时间：</p>
            <p class="con">{{ dataItem.order_time }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单状态：</p>
            <p class="con">
              {{
                dataItem.service_order_status == 1
                  ? "待接单"
                  : dataItem.service_order_status == 2
                  ? "已接单"
                  : dataItem.service_order_status == 3
                  ? "取餐中"
                  : dataItem.service_order_status == 4
                  ? "送餐中"
                  : dataItem.service_order_status == 5
                  ? "待自提"
                  : dataItem.service_order_status == 6
                  ? "已送达"
                  : "已完成"
              }}
            </p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单情况：</p>
            <p class="con">
              {{
                dataItem.service_order_property == 1
                  ? "服务订单进行中"
                  : dataItem.service_order_property == 2
                  ? "服务订单取消申请中"
                  : dataItem.service_order_property == 3
                  ? "服务订单已取消"
                  : "服务订单已完成"
              }}
            </p>
          </div>
        </div>

        <div class="block_two">
          <div class="column flex-rowl">
            <p class="label">服务订单号：</p>
            <p class="con">{{ dataItem.service_order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单号：</p>
            <p class="con">{{ dataItem.order_id }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">送餐位置：</p>
            <p class="con">{{ dataItem.address_detail }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">关联取餐柜：</p>
            <p class="con">{{ dataItem.service_rating }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">用户姓名：</p>
            <p class="con">{{ dataItem.truename }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">联系电话：</p>
            <p class="con">{{ dataItem.customer_phone }}</p>
          </div>
          <div class="column flex-rowl">
            <p class="label">订单内容：</p>
            <p class="con">{{ dataItem.order_content }}</p>
          </div>
        </div>

        <div class="btn flex-colc">
          <template v-if="dataItem.service_order_status == 1">
            <div class="primary-button flex-rowl" @click="handleOrder(1)">
              <!-- <div class="primary-button flex-rowl" @click="handleQuery(1)"> -->
              <i class="iconfont icon-yuanquangouxuan"></i> 确认接单
            </div>
            <div class="primary-button-plain flex-rowl" @click="handleOrder(2)">
              <!-- <div class="primary-button-plain  flex-rowl" @click="handleQuery(2)"> -->
              <i class="iconfont icon-paizhao"></i> 确认接单并继续扫码
            </div>
          </template>
          <template v-else-if="dataItem.service_order_status >= 2">
            <div class="default-button">已接单</div>
          </template>
        </div>
      </div>

      <van-empty
        description="该订单不存在"
        v-if="!isLoading && dataItem == ''"
      />
    </div>

    <div class="custom_btn custom_btn_scance" @click="handleScance">
      扫码接单
    </div>
    <div class="custom_btn" @click="handleReturn">返回</div>
  </div>
</template>
  
<script>
import {
  getOrderInfo,
  orderSendManage,
  getToken,
  getTakeMeal,
  getSendMeal,
} from "../../api/api";
export default {
  name: "tOrderIndex",
  data() {
    return {
      isLoading: true,
      userInfo: "", // 用户信息
      dataItem: "", // 订单信息
      pickupInfo: "", // 取餐信息
      order_id: "", // 订单id
      token: "", // token

      type: 1, // 1-确认接单、2-确认接单后返回扫码
    };
  },
  created() {
    let { id } = this.$route.params;
    this.order_id = id;
    this.token = this.$store.state.Authorization;
    this.userInfo = this.$store.state.USERINFO;
    this.getToken();
  },
  methods: {
    // 获取token
    getToken(isSubmit) {
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);

          if (isSubmit) {
            this.orderSendManage(res.data.token);
          } else {
            this.getOrderInfo(res.data.token);
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 查看取餐订单
    getOrderInfo(token) {
      let { order_id } = this;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderInfo({ order_id, token }).then((res) => {
        if (res.error_code == 0) {
          if (Object.values(res.data).length != 0) {
            this.dataItem = res.data;
            this.pickupInfo =
              Object.values(res.data.pickup).length != 0 ? res.data.pickup : "";
          } else {
            this.dataItem = "";
          }
          this.isLoading = false;
          toast.clear();
          if (this.type == 2) {
            this.handleScance();
          }
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
          this.isLoading = false;
          toast.clear();
        }
      });
    },

    // 扫码
    handleScance() {
      this.$router.push(`/qrcode/4`);
    },

    handleQuery(type) {
      let { dataItem } = this;
      if (dataItem.service_order_status == "待接单") return;
      this.getToken(true);
      this.type = type;
    },

    // 触发接单事件
    handleOrder(type) {
      let { service_order_status, address_detail, order_id } = this.dataItem;
      if (service_order_status == "待接单") return;
      this.type = type;
      this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
        duration: 0,
      });
      getToken().then((res) => {
        if (res.error_code == 0) {
          this.$store.commit("changeLogin", res.data.token);
          this.getTakeSendMeal(order_id, address_detail, res.data.token);
          // console.log(address_detail,'====');
          // orderSendManage({
          //   token: res.data.token,
          //   order_id,
          //   get_staff_id: this.userInfo.openid,
          // }).then((res1) => {
          //   if (res1.error_code == 0) {
          //     // this.$toast.success("接单成功");
          //     // this.params.token = res.data.token;
          //     // setTimeout(() => {
          //     //   this.params.Page = 1;
          //     //   that.getOrderList(true);
          //     // }, 800);
          //     setTimeout(() => {
          //       this.getTakeMeal(res.data.token);
          //     }, 600);
          //   } else {
          //     this.$toast.fail(res.message || "接口失效，请稍后～");
          //   }
          // });
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 提交取餐
    getTakeMeal(token) {
      let { dataItem, userInfo } = this;
      let order_id = dataItem.order_id;
      let params = {
        order_id,
        token,
        pickup_staff_name: userInfo.truename,
        pickup_staff_id: userInfo.accountid,
        pickup_staff_contact: userInfo.mobile,
      };
      getTakeMeal(params).then((res) => {
        if (res.error_code == 0) {
          // this.$toast.success(res.message);
          // toast.clear();
          // setTimeout(() => {
          //   this.getOrderInfo(order_id, token);
          // }, 500);
          setInterval(() => {
            this.getSendMeal(token);
          }, 600);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 提交送餐
    getSendMeal(token) {
      let { dataItem, userInfo } = this;
      let order_id = dataItem.order_id;
      // this.$toast.loading({
      //   message: "请稍后...",
      //   forbidClick: true,
      //   duration: 0,
      // });
      let params = {
        order_id,
        token,
        delivery_staff_name: userInfo.truename,
        delivery_staff_id: userInfo.accountid,
        delivery_staff_contact: userInfo.mobile,
        current_location: dataItem.address_detail,
      };
      getSendMeal(params).then((res) => {
        if (res.error_code == 0) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.params.Page = 1;
            this.getOrderList(true);
          }, 500);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 根据需求调整，接单-取餐-送餐合并
    async getTakeSendMeal(order_id, address_detail, token) {
      let { userInfo } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
        duration: 0,
      });
      // 1、接单
      let sendParams = {
        token: token,
        order_id,
        get_staff_id: userInfo.openid,
      };
      let res3 = await orderSendManage(sendParams);
      if (res3.error_code == 0) {
        // 2、取餐
        let takeParams = {
          order_id,
          token,
          pickup_staff_name: userInfo.truename,
          pickup_staff_id: userInfo.accountid,
          pickup_staff_contact: userInfo.mobile,
        };
        let res1 = await getTakeMeal(takeParams);
        if (res1.error_code == 0) {
          // 3、送餐
          let sendParams = {
            order_id,
            token,
            delivery_staff_name: userInfo.truename,
            delivery_staff_id: userInfo.accountid,
            delivery_staff_contact: userInfo.mobile,
            current_location: address_detail,
          };
          let res2 = await getSendMeal(sendParams);
          if (res2.error_code == 0) {
            toast.clear();
            this.$toast.success(res2.message || "接口失效，请稍后～");
            setTimeout(() => {
              this.getOrderInfo(token);
            }, 500);
          } else {
            this.$toast.fail(res2.message || "接口失效，请稍后～");
            setTimeout(() => {
              this.getOrderInfo(token);
            }, 500);
          }
        } else {
          this.$toast.fail(res1.message || "接口失效，请稍后～");
          setTimeout(() => {
            this.getOrderInfo(token);
          }, 500);
        }
      } else {
        this.$toast.fail(res3.message || "接口失效，请稍后～");
        setTimeout(() => {
          this.getOrderInfo(token);
        }, 500);
      }
    },

    orderSendManage(token) {
      let { order_id, userInfo } = this;
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      let params = {
        order_id,
        token,
        get_staff_id: userInfo.openid,
      };
      orderSendManage(params).then((res) => {
        if (res.error_code == 0) {
          toast.clear();
          this.$toast.success(res.message);
          setTimeout(() => {
            this.getOrderInfo(token);
          }, 500);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    // 拒绝取餐
    handleRefuse() {
      this.$router.push(`/tekeMeal/tMealRefuse/${this.order_id}`);
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.indexPage {
  padding-top: 40px;
  .list {
    .item {
      width: 660px;
      min-height: 700px;
      background: #ffffff;
      border: 6px solid #e6e6e6;
      border-radius: 40px;
      margin: 0 auto 30px;
      padding: 52px 44px 0;
      box-sizing: border-box;
      font-size: 28px;
      color: #040000;
      .block_one {
        font-size: 22px;
        margin-bottom: 65px;
        .column {
          .label {
            width: 140px;
          }
        }
      }
      .block_two {
        margin-bottom: 99px;
      }
      .block_three {
        margin-bottom: 85px;
      }
      .btn {
        margin-bottom: 60px;
        align-items: flex-end;
        .primary-button {
          width: 230px;
          position: relative;
          margin-bottom: 30px;
        }
        .primary-button-plain {
          padding: 0 35px 0 10px;
          width: auto;
          margin-left: 30px;
          position: relative;
        }
        .iconfont {
          margin: 0 20px 0 17px;
          // position: absolute;
          // left: 17px;
          &.icon-paizhao {
            font-size: 40px;
          }
          &.icon-yuanquangouxuan {
            font-size: 38px;
          }
        }
      }
      .column {
        align-items: flex-start;
        &:nth-child(2n) {
          margin: 26px 0;
        }
        .label {
          white-space: nowrap;
          width: 190px;
          flex-shrink: 0;
        }
        .con {
          word-wrap: break-word;
          flex-shrink: 0;
          width: 380px;
        }
      }
    }
  }
  .custom_btn_scance {
    margin: 70px auto 30px;
  }
}
</style>